import HistoricBondCreatePage from "./components/HistoricBondCreatePage";
import useTrusteeBondCreateHistoric from "./hooks/useTrusteeBondCreateHistoric";
import TrusteeHistoricBasicInformationForm from "./components/TrusteeHistoricBasicInformationForm";
import TrusteeHistoricGuardianForm from "./components/TrusteeHistoricGuardianForm";
import TrusteeHistoricAttorneyInformationForm from "./components/TrusteeHistoricAttorneyInformationForm";
import { ObligeeInformationForm } from "./Helpers/ObligeeInformation";
import TrusteeHistoricRequestorInformationForm from "./components/TrusteeHistoricRequestorInformationForm";
import { BillingInformationForm } from "./Helpers/BillingInformation";
import TrusteeHistoricOtherDetailsForm from "./components/TrusteeHistoricOtherDetailsForm";
import TrusteeHistoricBondNumberSection from "./components/TrusteeHistoricBondNumberSection";

const TrusteeBondCreateHistoric = () => (
  <HistoricBondCreatePage
    bondKindLabel="Trustee"
    useCreateHook={useTrusteeBondCreateHistoric}
    sections={[
      { key: "basic", Component: TrusteeHistoricBasicInformationForm, stateKey: "basicInformation" },
      { key: "guardian", Component: TrusteeHistoricGuardianForm, stateKey: "guardianDetails" },
      { key: "attorney", Component: TrusteeHistoricAttorneyInformationForm, stateKey: "attorneyInformation" },
      { key: "obligee", Component: ObligeeInformationForm, stateKey: "obligeeInformation" },
      { key: "requestor", Component: TrusteeHistoricRequestorInformationForm, stateKey: "requestorInformation" },
      { key: "billing", Component: BillingInformationForm, stateKey: "billingInformation" },
      { key: "other", Component: TrusteeHistoricOtherDetailsForm, stateKey: "otherDetails" },
      {
        key: "bondNumber",
        render: ({ globalState, updateGlobalState, errors }) => (
          <TrusteeHistoricBondNumberSection
            data={globalState.otherDetails}
            updateData={(data) => updateGlobalState("otherDetails", data)}
            errors={errors}
          />
        ),
      },
    ]}
    submitDisabled={(globalState) => globalState?.basicInformation?.judgeStern === "No"}
  />
);

export default TrusteeBondCreateHistoric;
